const SelectedIconMobile = () => (
  <svg className="selected-icon-mobile" fill="none" height="12" viewBox="0 0 11 12" width="11" xmlns="http://www.w3.org/2000/svg">
    <rect fill="#00BD00" height="11" rx="5.5" width="11" y="0.959961" />
    <path d="M4.96934 9L3 7.00193L3.89746 6.09138L4.96934 7.18211L8.10254 4L9 4.91055L4.96934 9Z" fill="white" />
  </svg>
);

export default SelectedIconMobile;
